'use client';

import { useEffect, useState } from 'react';
import styles from './VideoPlayer.module.scss';

interface PlayButtonProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

export default function PlayButton({ videoRef }: PlayButtonProps) {
  const [isPlaying, setIsPlaying] = useState(true);

  // Initialize isPlaying state based on videoRef
  useEffect(() => {
    if (videoRef.current) {
      setIsPlaying(videoRef.current.autoplay);
    }
  }, [videoRef.current?.src]);

  const togglePlayVideo = () => {
    const newIsPlaying = !isPlaying;
    setIsPlaying(newIsPlaying);

    if (newIsPlaying) {
      videoRef.current?.play();
    } 
    else {
      videoRef.current?.pause();
    }
  }

  return (
    <div className={styles.playButton} onPointerDown={togglePlayVideo}>
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {isPlaying ? (
          // Pause: Two vertical bars
          <>
            <rect x="4" y="3" width="2.5" height="10" fill="currentColor"/>
            <rect x="9.5" y="3" width="2.5" height="10" fill="currentColor"/>
          </>
        ) : (
          // Play: Triangle
          <path d="M5 3 L13 8 L5 13 Z" fill="currentColor"/>
        )}
      </svg>
    </div>
  );
}